<template>
    <div class="wrapper">
        <img class="image" src="static/img/ship.avif">
        <p class="blockA">
            LD power automation is dedicated to providing reliable shore connection (cold ironing) services for the maritime industry.
            <br/>We specialize in ensuring vessels can seamlessly and safely connect to shore power, reducing emissions, improving efficiency, and supporting environmental compliance.
            <br/>Our experienced engineers handle every stage of the process — from installation and commissioning to troubleshooting and maintenance — guaranteeing professional and timely delivery. With extensive expertise across international standards and port requirements, we make sure your operations run without interruption.
            <br/>We are committed to building strong, long-term relationships with our clients, based on trust, technical excellence, and a deep understanding of their needs in shore power connection.
        </p>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'homedefault',
	data() {
		return {
			
		}
	},
}
</script>

<style scoped>
.wrapper {
    width: 100%;
    display: flex;
    color:black;
    font-size: 16px;
    letter-spacing: .05em;
    gap: 44px;
}

.image {
    flex: 1;
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
}

.blockA {
    flex: 1;
    margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomeDefault.vue